// Israeli cities with coordinates for marketplace location selection
export interface IsraeliCity {
  name: string
  nameHe: string
  lat: number
  lng: number
  region?: string
}

export const ISRAELI_CITIES: IsraeliCity[] = [
  // Major Cities
  { name: 'Jerusalem', nameHe: 'ירושלים', lat: 31.7683, lng: 35.2137, region: 'center' },
  { name: 'Tel Aviv', nameHe: 'תל אביב-יפו', lat: 32.0853, lng: 34.7818, region: 'center' },
  { name: 'Haifa', nameHe: 'חיפה', lat: 32.7940, lng: 34.9896, region: 'north' },
  { name: 'Rishon LeZion', nameHe: 'ראשון לציון', lat: 31.9730, lng: 34.7925, region: 'center' },
  { name: 'Petah Tikva', nameHe: 'פתח תקווה', lat: 32.0841, lng: 34.8878, region: 'center' },
  { name: 'Ashdod', nameHe: 'אשדוד', lat: 31.8044, lng: 34.6553, region: 'south' },
  { name: 'Netanya', nameHe: 'נתניה', lat: 32.3215, lng: 34.8532, region: 'sharon' },
  { name: 'Beer Sheva', nameHe: 'באר שבע', lat: 31.2518, lng: 34.7913, region: 'south' },
  { name: 'Bnei Brak', nameHe: 'בני ברק', lat: 32.0833, lng: 34.8333, region: 'center' },
  { name: 'Holon', nameHe: 'חולון', lat: 32.0114, lng: 34.7875, region: 'center' },
  { name: 'Ramat Gan', nameHe: 'רמת גן', lat: 32.0700, lng: 34.8200, region: 'center' },
  { name: 'Ashkelon', nameHe: 'אשקלון', lat: 31.6688, lng: 34.5743, region: 'south' },
  { name: 'Rehovot', nameHe: 'רחובות', lat: 31.8928, lng: 34.8113, region: 'center' },
  { name: 'Bat Yam', nameHe: 'בת ים', lat: 32.0231, lng: 34.7503, region: 'center' },
  { name: 'Beit Shemesh', nameHe: 'בית שמש', lat: 31.7456, lng: 34.9867, region: 'center' },
  { name: 'Kfar Saba', nameHe: 'כפר סבא', lat: 32.1780, lng: 34.9077, region: 'sharon' },
  { name: 'Herzliya', nameHe: 'הרצליה', lat: 32.1667, lng: 34.8333, region: 'sharon' },
  { name: 'Hadera', nameHe: 'חדרה', lat: 32.4340, lng: 34.9196, region: 'sharon' },
  { name: 'Modiin', nameHe: "מודיעין-מכבים-רעות", lat: 31.8977, lng: 35.0105, region: 'center' },
  { name: 'Nazareth', nameHe: 'נצרת', lat: 32.7021, lng: 35.2978, region: 'north' },
  { name: 'Lod', nameHe: 'לוד', lat: 31.9514, lng: 34.8879, region: 'center' },
  { name: 'Ramla', nameHe: 'רמלה', lat: 31.9275, lng: 34.8625, region: 'center' },
  { name: 'Raanana', nameHe: 'רעננה', lat: 32.1840, lng: 34.8714, region: 'sharon' },
  { name: 'Nahariya', nameHe: 'נהריה', lat: 33.0081, lng: 35.0945, region: 'north' },
  { name: 'Givatayim', nameHe: 'גבעתיים', lat: 32.0717, lng: 34.8100, region: 'center' },
  { name: 'Hod HaSharon', nameHe: 'הוד השרון', lat: 32.1500, lng: 34.8833, region: 'sharon' },
  // Kiryat cities
  { name: 'Kiryat Ata', nameHe: 'קרית אתא', lat: 32.8000, lng: 35.1000, region: 'north' },
  { name: 'Kiryat Gat', nameHe: 'קרית גת', lat: 31.6100, lng: 34.7700, region: 'south' },
  { name: 'Kiryat Motzkin', nameHe: 'קרית מוצקין', lat: 32.8400, lng: 35.0800, region: 'north' },
  { name: 'Kiryat Shmona', nameHe: 'קרית שמונה', lat: 33.2075, lng: 35.5697, region: 'north' },
  { name: 'Kiryat Yam', nameHe: 'קרית ים', lat: 32.8500, lng: 35.0667, region: 'north' },
  { name: 'Kiryat Bialik', nameHe: 'קרית ביאליק', lat: 32.8333, lng: 35.0833, region: 'north' },
  { name: 'Kiryat Malakhi', nameHe: 'קרית מלאכי', lat: 31.7300, lng: 34.7400, region: 'south' },
  { name: 'Kiryat Ono', nameHe: 'קרית אונו', lat: 32.0636, lng: 34.8553, region: 'center' },
  { name: 'Kiryat Tivon', nameHe: 'קרית טבעון', lat: 32.7200, lng: 35.1200, region: 'north' },
  { name: 'Kiryat Ekron', nameHe: 'קריית עקרון', lat: 31.8653, lng: 34.8214, region: 'center' },
  // South
  { name: 'Eilat', nameHe: 'אילת', lat: 29.5577, lng: 34.9519, region: 'south' },
  { name: 'Dimona', nameHe: 'דימונה', lat: 31.0680, lng: 35.0328, region: 'south' },
  { name: 'Ofakim', nameHe: 'אופקים', lat: 31.3167, lng: 34.6167, region: 'south' },
  { name: 'Arad', nameHe: 'ערד', lat: 31.2614, lng: 35.2131, region: 'south' },
  { name: 'Sderot', nameHe: 'שדרות', lat: 31.5244, lng: 34.5968, region: 'south' },
  { name: 'Netivot', nameHe: 'נתיבות', lat: 31.4200, lng: 34.5900, region: 'south' },
  { name: 'Yeruham', nameHe: 'ירוחם', lat: 30.9876, lng: 34.9294, region: 'south' },
  { name: 'Mitzpe Ramon', nameHe: 'מצפה רמון', lat: 30.6100, lng: 34.8000, region: 'south' },
  { name: 'Rahat', nameHe: 'רהט', lat: 31.3936, lng: 34.7539, region: 'south' },
  { name: 'Laqye', nameHe: 'לקיה', lat: 31.3333, lng: 34.7833, region: 'south' },
  { name: 'Kuseife', nameHe: 'כסיפה', lat: 31.2333, lng: 34.9833, region: 'south' },
  { name: 'Hura', nameHe: 'חורה', lat: 31.2933, lng: 34.9322, region: 'south' },
  { name: 'Tel Sheva', nameHe: 'תל שבע', lat: 31.2500, lng: 34.8167, region: 'south' },
  { name: 'Segev Shalom', nameHe: 'שגב-שלום', lat: 31.2500, lng: 34.9500, region: 'south' },
  { name: 'Arara BaNegev', nameHe: 'ערערה בנגב', lat: 31.2667, lng: 34.9000, region: 'south' },
  { name: 'Meitar', nameHe: 'מיתר', lat: 31.3250, lng: 34.9333, region: 'south' },
  { name: 'Omer', nameHe: 'עומר', lat: 31.2833, lng: 34.8500, region: 'south' },
  { name: 'Lehavim', nameHe: 'להבים', lat: 31.3744, lng: 34.8100, region: 'south' },
  // North
  { name: 'Acre', nameHe: 'עכו', lat: 32.9333, lng: 35.0833, region: 'north' },
  { name: 'Afula', nameHe: 'עפולה', lat: 32.6100, lng: 35.2900, region: 'north' },
  { name: 'Yokneam', nameHe: 'יקנעם עילית', lat: 32.6594, lng: 35.1064, region: 'north' },
  { name: 'Karmiel', nameHe: 'כרמיאל', lat: 32.9136, lng: 35.2961, region: 'north' },
  { name: 'Tiberias', nameHe: 'טבריה', lat: 32.7922, lng: 35.5312, region: 'north' },
  { name: 'Nesher', nameHe: 'נשר', lat: 32.7700, lng: 35.0400, region: 'north' },
  { name: 'Zefat', nameHe: 'צפת', lat: 32.9646, lng: 35.4960, region: 'north' },
  { name: 'Tamra', nameHe: 'טמרה', lat: 32.8536, lng: 35.1992, region: 'north' },
  { name: 'Sakhnin', nameHe: 'סח׳נין', lat: 32.8667, lng: 35.3000, region: 'north' },
  { name: 'Tirat Carmel', nameHe: 'טירת כרמל', lat: 32.7600, lng: 34.9700, region: 'north' },
  { name: 'Migdal HaEmek', nameHe: 'מגדל העמק', lat: 32.6800, lng: 35.2400, region: 'north' },
  { name: 'Maalot-Tarshiha', nameHe: 'מעלות-תרשיחא', lat: 33.0167, lng: 35.2667, region: 'north' },
  { name: 'Beit Shean', nameHe: 'בית שאן', lat: 32.5000, lng: 35.5000, region: 'north' },
  { name: 'Nof HaGalil', nameHe: 'נוף הגליל', lat: 32.7000, lng: 35.3200, region: 'north' },
  { name: 'Shfaram', nameHe: 'שפרעם', lat: 32.8050, lng: 35.1700, region: 'north' },
  { name: 'Umm al-Fahm', nameHe: 'אום אל-פחם', lat: 32.5167, lng: 35.1500, region: 'north' },
  { name: 'Baqa al-Gharbiyye', nameHe: 'באקה אל-גרבייה', lat: 32.4167, lng: 35.0500, region: 'north' },
  { name: 'Atlit', nameHe: 'עתלית', lat: 32.6867, lng: 34.9400, region: 'north' },
  { name: 'Kfar Tavor', nameHe: 'כפר תבור', lat: 32.6878, lng: 35.4178, region: 'north' },
  { name: 'Zarzir', nameHe: 'זרזיר', lat: 32.7242, lng: 35.2608, region: 'north' },
  { name: 'Daliyat al-Karmel', nameHe: 'דלית אל-כרמל', lat: 32.6917, lng: 35.0500, region: 'north' },
  { name: 'Isfiya', nameHe: 'עוספיה', lat: 32.7167, lng: 35.0667, region: 'north' },
  { name: 'Fureidis', nameHe: 'פוריידיס', lat: 32.6100, lng: 34.9500, region: 'north' },
  { name: 'Jisr az-Zarqa', nameHe: 'ג׳סר א-זרקא', lat: 32.5333, lng: 34.9000, region: 'north' },
  { name: 'Tuba-Zangariyye', nameHe: 'טובא-זנגרייה', lat: 32.9600, lng: 35.5200, region: 'north' },
  { name: 'Rama', nameHe: 'ראמה', lat: 32.9333, lng: 35.3667, region: 'north' },
  { name: 'Majd al-Krum', nameHe: 'מג׳ד אל-כרום', lat: 32.9167, lng: 35.2500, region: 'north' },
  { name: 'Deir al-Asad', nameHe: 'דיר אל-אסד', lat: 32.9333, lng: 35.2667, region: 'north' },
  { name: 'Kabul', nameHe: 'כאבול', lat: 32.8667, lng: 35.2167, region: 'north' },
  { name: 'Yafa', nameHe: 'יפיע', lat: 32.6833, lng: 35.2667, region: 'north' },
  { name: 'Kafr Kanna', nameHe: 'כפר כנא', lat: 32.7500, lng: 35.3333, region: 'north' },
  { name: 'Eilabun', nameHe: 'עיילבון', lat: 32.8333, lng: 35.4000, region: 'north' },
  { name: 'Bueine Nujeidat', nameHe: 'בועיינה-נוג׳ידאת', lat: 32.7500, lng: 35.3500, region: 'north' },
  { name: 'Kafr Manda', nameHe: 'כפר מנדא', lat: 32.8000, lng: 35.2667, region: 'north' },
  { name: 'Hazor HaGlilit', nameHe: 'חצור הגלילית', lat: 32.9833, lng: 35.5333, region: 'north' },
  { name: 'Rosh Pina', nameHe: 'ראש פינה', lat: 32.9667, lng: 35.5333, region: 'north' },
  { name: 'Metula', nameHe: 'מטולה', lat: 33.2778, lng: 35.5778, region: 'north' },
  { name: 'Shlomi', nameHe: 'שלומי', lat: 33.0742, lng: 35.1439, region: 'north' },
  { name: 'Kfar Vradim', nameHe: 'כפר ורדים', lat: 32.9833, lng: 35.2833, region: 'north' },
  { name: 'Maghar', nameHe: 'מגאר', lat: 32.8833, lng: 35.4167, region: 'north' },
  { name: 'Reineh', nameHe: 'ריינה', lat: 32.7167, lng: 35.3000, region: 'north' },
  { name: 'Arraba', nameHe: 'עראבה', lat: 32.8500, lng: 35.3333, region: 'north' },
  { name: 'Daburiyya', nameHe: 'דבוריה', lat: 32.6833, lng: 35.3667, region: 'north' },
  { name: 'Iksal', nameHe: 'אכסאל', lat: 32.6667, lng: 35.3167, region: 'north' },
  { name: 'Judeida-Makr', nameHe: 'ג׳דיידה-מכר', lat: 32.9267, lng: 35.1556, region: 'north' },
  { name: 'Abu Snan', nameHe: 'אבו סנאן', lat: 32.9500, lng: 35.1667, region: 'north' },
  { name: 'Kisra-Sumei', nameHe: 'כסרא-סמיע', lat: 33.0167, lng: 35.3500, region: 'north' },
  { name: 'Yanuh-Jat', nameHe: 'ינוח-ג׳ת', lat: 32.9500, lng: 35.2333, region: 'north' },
  { name: 'Pekiin', nameHe: 'פקיעין', lat: 32.9667, lng: 35.3333, region: 'north' },
  { name: 'Hurfeish', nameHe: 'חורפיש', lat: 33.0167, lng: 35.3333, region: 'north' },
  { name: 'Beit Jann', nameHe: 'בית ג׳ן', lat: 32.9500, lng: 35.3833, region: 'north' },
  { name: 'Kafr Qara', nameHe: 'כפר קרע', lat: 32.5000, lng: 35.0667, region: 'north' },
  { name: 'Jatt', nameHe: 'ג׳ת', lat: 32.4000, lng: 35.0667, region: 'north' },
  { name: 'Yavneel', nameHe: 'יבנאל', lat: 32.7167, lng: 35.5000, region: 'north' },
  { name: 'Ein Mahil', nameHe: 'עין מאהל', lat: 32.7500, lng: 35.3167, region: 'north' },
  { name: 'Nahf', nameHe: 'נחף', lat: 32.9167, lng: 35.3167, region: 'north' },
  { name: 'Kafr Yasif', nameHe: 'כפר יאסיף', lat: 32.9500, lng: 35.1667, region: 'north' },
  { name: 'Mughar', nameHe: 'מע׳אר', lat: 32.8833, lng: 35.4167, region: 'north' },
  { name: 'Ilut', nameHe: 'אעבלין', lat: 32.8167, lng: 35.2167, region: 'north' },
  // Center
  { name: 'Rosh HaAyin', nameHe: 'ראש העין', lat: 32.0956, lng: 34.9567, region: 'center' },
  { name: 'Or Yehuda', nameHe: 'אור יהודה', lat: 32.0306, lng: 34.8556, region: 'center' },
  { name: 'Givat Shmuel', nameHe: 'גבעת שמואל', lat: 32.0800, lng: 34.8500, region: 'center' },
  { name: 'Yehud', nameHe: 'יהוד-מונוסון', lat: 32.0333, lng: 34.8833, region: 'center' },
  { name: 'Yavne', nameHe: 'יבנה', lat: 31.8786, lng: 34.7397, region: 'center' },
  { name: 'Ness Ziona', nameHe: 'נס ציונה', lat: 31.9294, lng: 34.7978, region: 'center' },
  { name: 'Gan Yavne', nameHe: 'גן יבנה', lat: 31.7867, lng: 34.7069, region: 'center' },
  { name: 'Shoham', nameHe: 'שוהם', lat: 31.9972, lng: 34.9475, region: 'center' },
  { name: 'Elad', nameHe: 'אלעד', lat: 32.0522, lng: 34.9517, region: 'center' },
  { name: 'Maale Adumim', nameHe: 'מעלה אדומים', lat: 31.7780, lng: 35.3000, region: 'center' },
  { name: 'Modiin Illit', nameHe: 'מודיעין עילית', lat: 31.9333, lng: 35.0433, region: 'center' },
  { name: 'Beitar Illit', nameHe: 'ביתר עילית', lat: 31.6969, lng: 35.1222, region: 'center' },
  { name: 'Ariel', nameHe: 'אריאל', lat: 32.1067, lng: 35.1733, region: 'center' },
  { name: 'Gedera', nameHe: 'גדרה', lat: 31.8122, lng: 34.7783, region: 'center' },
  { name: 'Ramat HaSharon', nameHe: 'רמת השרון', lat: 32.1464, lng: 34.8400, region: 'center' },
  { name: 'Kafr Qasim', nameHe: 'כפר קאסם', lat: 32.1136, lng: 34.9758, region: 'center' },
  { name: 'Azor', nameHe: 'אזור', lat: 32.0256, lng: 34.7917, region: 'center' },
  { name: 'Tira', nameHe: 'טירה', lat: 32.2333, lng: 34.9500, region: 'center' },
  { name: 'Taybeh', nameHe: 'טייבה', lat: 32.2667, lng: 35.0000, region: 'center' },
  { name: 'Qalansawe', nameHe: 'קלנסווה', lat: 32.2833, lng: 34.9833, region: 'center' },
  { name: 'Jaljulia', nameHe: 'ג׳לג׳וליה', lat: 32.1500, lng: 34.9667, region: 'center' },
  { name: 'Arara', nameHe: 'ערערה', lat: 32.5000, lng: 35.0833, region: 'center' },
  { name: 'Mevaseret Zion', nameHe: 'מבשרת ציון', lat: 31.8028, lng: 35.1500, region: 'center' },
  { name: 'Ganei Tikva', nameHe: 'גני תקווה', lat: 32.0567, lng: 34.8750, region: 'center' },
  { name: 'Beer Yaakov', nameHe: 'באר יעקב', lat: 31.9333, lng: 34.8333, region: 'center' },
  { name: 'Mazkeret Batya', nameHe: 'מזכרת בתיה', lat: 31.8500, lng: 34.7833, region: 'center' },
  { name: 'Givat Zeev', nameHe: 'גבעת זאב', lat: 31.8600, lng: 35.1700, region: 'center' },
  { name: 'Efrat', nameHe: 'אפרת', lat: 31.6600, lng: 35.1500, region: 'center' },
  { name: 'Karnei Shomron', nameHe: 'קרני שומרון', lat: 32.1700, lng: 35.0900, region: 'center' },
  { name: 'Alfei Menashe', nameHe: 'אלפי מנשה', lat: 32.1667, lng: 35.0167, region: 'center' },
  { name: 'Emanuel', nameHe: 'עמנואל', lat: 32.1500, lng: 35.1500, region: 'center' },
  { name: 'Kedumim', nameHe: 'קדומים', lat: 32.1833, lng: 35.1833, region: 'center' },
  { name: 'Savyon', nameHe: 'סביון', lat: 32.0489, lng: 34.8736, region: 'center' },
  { name: 'Kafr Bara', nameHe: 'כפר ברא', lat: 32.1333, lng: 34.9833, region: 'center' },
  { name: 'Kochav Yair', nameHe: 'כוכב יאיר-צור יגאל', lat: 32.2222, lng: 34.9611, region: 'center' },
  { name: 'Beit Aryeh', nameHe: 'בית אריה', lat: 32.0417, lng: 35.0417, region: 'center' },
  { name: 'Oranit', nameHe: 'אורנית', lat: 32.1333, lng: 35.0000, region: 'center' },
  { name: 'Elkana', nameHe: 'אלקנה', lat: 32.1167, lng: 35.0333, region: 'center' },
  { name: 'Kiryat Yearim', nameHe: 'קריית יערים', lat: 31.8000, lng: 35.1000, region: 'center' },
  { name: 'Abu Ghosh', nameHe: 'אבו גוש', lat: 31.7964, lng: 35.1092, region: 'center' },
  { name: 'Beit Dagan', nameHe: 'בית דגן', lat: 31.9967, lng: 34.8233, region: 'center' },
  // Sharon
  { name: 'Harish', nameHe: 'חריש', lat: 32.4567, lng: 35.0467, region: 'sharon' },
  { name: 'Pardes Hanna-Karkur', nameHe: 'פרדס חנה-כרכור', lat: 32.4700, lng: 34.9700, region: 'sharon' },
  { name: 'Or Akiva', nameHe: 'אור עקיבא', lat: 32.5100, lng: 34.9200, region: 'sharon' },
  { name: 'Tzur Yigal', nameHe: 'צור יגאל', lat: 32.2306, lng: 34.9392, region: 'sharon' },
  { name: 'Even Yehuda', nameHe: 'אבן יהודה', lat: 32.2700, lng: 34.8900, region: 'sharon' },
  { name: 'Kadima-Zoran', nameHe: 'קדימה-צורן', lat: 32.2800, lng: 34.9100, region: 'sharon' },
  { name: 'Binyamina-Givat Ada', nameHe: 'בנימינה-גבעת עדה', lat: 32.5200, lng: 34.9500, region: 'sharon' },
  { name: 'Zikhron Yaakov', nameHe: 'זכרון יעקב', lat: 32.5700, lng: 34.9500, region: 'sharon' },
  { name: 'Caesarea', nameHe: 'קיסריה', lat: 32.5000, lng: 34.8900, region: 'sharon' },
  { name: 'Kfar Yona', nameHe: 'כפר יונה', lat: 32.3167, lng: 34.9333, region: 'sharon' },
  { name: 'Tel Mond', nameHe: 'תל מונד', lat: 32.2567, lng: 34.9233, region: 'sharon' },
  { name: 'Ganot', nameHe: 'גנות', lat: 32.2500, lng: 34.8833, region: 'sharon' },
  { name: 'Emek Hefer', nameHe: 'עמק חפר', lat: 32.3500, lng: 34.9000, region: 'sharon' },
]

// Group cities by region
export const CITIES_BY_REGION = {
  center: ISRAELI_CITIES.filter(c => c.region === 'center'),
  north: ISRAELI_CITIES.filter(c => c.region === 'north'),
  south: ISRAELI_CITIES.filter(c => c.region === 'south'),
  sharon: ISRAELI_CITIES.filter(c => c.region === 'sharon'),
}

// Region labels in Hebrew
export const REGION_LABELS = {
  center: 'מרכז',
  north: 'צפון',
  south: 'דרום',
  sharon: 'השרון',
}

// Find city by name (English or Hebrew)
export function findCity(query: string): IsraeliCity | undefined {
  const q = query.toLowerCase().trim()
  return ISRAELI_CITIES.find(
    c => c.name.toLowerCase() === q || c.nameHe === query.trim()
  )
}

// Normalize Hebrew spelling variations for search (e.g. קרית/קריית)
function normalizeHebrew(str: string): string {
  return str.replace(/קריית/g, 'קרית').replace(/׳/g, "'")
}

// Search cities by partial match
export function searchCities(query: string): IsraeliCity[] {
  if (!query || query.length < 2) return []
  const q = query.toLowerCase().trim()
  const qHe = normalizeHebrew(query.trim())
  return ISRAELI_CITIES.filter(
    c => c.name.toLowerCase().includes(q) || c.nameHe.includes(query) || normalizeHebrew(c.nameHe).includes(qHe)
  ).slice(0, 10)
}
